import { render, staticRenderFns } from "./PlayerShow.vue?vue&type=template&id=55943853&scoped=true&"
import script from "./PlayerShow.vue?vue&type=script&lang=js&"
export * from "./PlayerShow.vue?vue&type=script&lang=js&"
import style0 from "./PlayerShow.vue?vue&type=style&index=0&id=55943853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55943853",
  null
  
)

export default component.exports